import React, { useEffect, useState } from "react";
import { NormalHeading } from "../../../../Components/Utils/Heading";
import {
  BackButton,
  CancelButton,
  CreateButton,
  DownloadButton,
  EditButton,
} from "../../../../Components/Utils/Buttons";
import { Link, useLocation, useParams } from "react-router-dom";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import SideModal from "../../../../Components/Others/SideModel";
import axiosInstance from "../../../../Services/axiosCommon";
import NuDate from "../../../../Components/Utils/NuDate";
import PDFLinkRFQ from "./pdf/PDFLinkRFQ";
import ViewPdf from "./ViewPdf";
import Comments from "./CommentsPr";
import CommonComments from "../../../../Components/Utils/commonComments";
import capitalizeFirstLetter from "../../../../Components/Utils/Funcs";
import Modal from "../../../../Components/Utils/AttachmentView";
import DeleteIcon from "../../../../Components/Icons/Delete";
import { Tab, Tabs } from "../../../../Layouts/MainPage/Tabs";
import NuAmount from "../../../../Components/Utils/NuAmount";
import ModalContainer from "../../../../Components/Others/ModalContainer";
// import { useDeleteData } from '../../../../Components/Hooks/useDeleteData';
import SQPdfOthers from "../../ViewPdfTemplate/SQPdfOthers";
import FilesView from "../../../../Components/Utils/FilesView";
import PDFViewer from "../../../../Components/Utils/PDFViewer";
import { formatDisplaySno, formatDisplaySno2 } from "../../../../Components/Utils/formatDisplaySno";
import { useToast } from "../../../../Components/Others/ToastServices";
import Xls from "../../../../Components/Icons/Xls";
import Xlss from "../../../../Components/Icons/Xlss";

import { useQuery } from "@tanstack/react-query";

function ViewRFQ() {
  const { rfqViewId } = useParams();
  const toast = useToast();

  const location = useLocation();

  const pageIndex = location.state?.pageIndex;
  const searchQuery = location.state?.searchQuery;

  const active = location?.state?.active || null;
  console.log(active, "llssss");
  console.log("finding", location?.state?.state?.active);

  const [data, setData] = useState([]);

  // Fetch RFQ Details using React Query
  const { data: fetchedRfqData, refetch: refetchRfq } = useQuery({
    queryKey: ["RFQ-details", rfqViewId],
    queryFn: async () => {
      const res = await axiosInstance.get(`/rfq/${rfqViewId}`);
      return res.data?.data || null;
    },
    enabled: !!rfqViewId,
    refetchOnMount: "always",
    staleTime: 0,
  });

  useEffect(() => {
    if (fetchedRfqData) {
      setData(fetchedRfqData);
    }
  }, [fetchedRfqData]);

  const [QData, setQData] = useState([]);
  const getSQById = (id) => {
    if (!id) {
      console.error("Error: ID is required but was not provided.");
      return;
    }
    axiosInstance
      .get(`/supplier-quotations/${id}`)
      .then((res) => {
        console.log("rfqget", res?.data?.data);
        setQData(res?.data?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (data?.supplierQuote) {
      getSQById(data?.supplierQuote);
    }
  }, [data?.supplierQuote]);

  const [activeButton, setActiveButton] = useState(1);
  const handleButtonClick = (buttonNumber) => {
    setActiveButton(buttonNumber);
  };
  const [isCommentsModalOpen, setIsCommentsModalOpen] = useState(false);
  const [prlist, setPrlist] = useState([]);
  const [showPdfComponent, setShowPdfComponent] = useState(false);
  const [showPdfComponentSQ, setShowPdfComponentSQ] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  useEffect(() => {
    if (active == 2) {
      setActiveButton(2);
    }
  }, [active]);

  const handleOpenCommentsModal = () => {
    setIsCommentsModalOpen(true);
  };

  const [pdfLoading, setPdfLoading] = useState(false);
  const [pdfLoadingSQ, setPdfLoadingSQ] = useState(false);

  const handlePdfIconClick = async () => {
    setShowPdfComponent(true);
    if (!viewPDF) {
      setPdfLoading(true);
      await ViewPDF();
      setPdfLoading(false);
    }
  };
  const handlePdfIconClickSQ = async () => {
    setShowPdfComponentSQ(true);
    if (!viewSQPDF && data?.supplierQuote) {
      setPdfLoadingSQ(true);
      await ViewSQPDF(data?.supplierQuote);
      setPdfLoadingSQ(false);
    }
  };
  // const getPr = () => {
  //   axiosInstance.get(`/PR/pr-products/${data.prId}`).then((res) => {
  //     if (res?.data?.data) {
  //       setPrlist(res.data.data);
  //       // data.productList = res.data.data;
  //     }
  //   }).catch((err)=>{
  //     console.log(err);
  //   })
  // };

  // useEffect(() => {
  //   getPr();
  // }, [data.prId]);

  const getInitials = (name) => {
    const names = name.split(" ");
    if (names.length > 1) {
      return names[0][0] + names[1][0];
    }
    return names[0][0];
  };

  const downloadPDF = async () => {
    try {
      const response = await axiosInstance.get(
        `/rfq/download-pdf/${rfqViewId}`,
        {
          responseType: "blob", // Important to specify the response type as blob
        },
      );

      // Create a Blob from the response
      const pdfBlob = new Blob([response.data], { type: "application/pdf" });

      // Create a link element
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(pdfBlob);
      link.download = `${data.ref}.pdf`; // The filename you want for the downloaded file

      // Append the link to the body (required for Firefox)
      document.body.appendChild(link);

      // Programmatically click the link to trigger the download
      link.click();

      // Clean up and remove the link
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error("Error downloading the PDF:", error);
    }
  };

  const downloadSQPDF = async () => {
    try {
      const response = await axiosInstance.get(
        `/supplier-quotations/download-pdf/${data?.supplierQuote}`,
        {
          responseType: "blob", // Important to specify the response type as blob
        },
      );

      // Create a Blob from the response
      const pdfBlob = new Blob([response.data], { type: "application/pdf" });

      // Create a link element
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(pdfBlob);
      link.download = `${QData?.ref}.pdf`; // The filename you want for the downloaded file

      // Append the link to the body (required for Firefox)
      document.body.appendChild(link);

      // Programmatically click the link to trigger the download
      link.click();

      // Clean up and remove the link
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error("Error downloading the PDF:", error);
    }
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [filePathList, setFilePathList] = useState([]);
  const [filePathListSQ, setFilePathListSQ] = useState([]);

  useEffect(() => {
    if (
      data?.attachments !== null &&
      data?.attachments !== "None" &&
      data?.attachments !== "[]"
    ) {
      setFilePathList(data?.attachments?.length > 0 ? data?.attachments : []);
      // console.log('image',createNew?.attachments);
      // setRemoveFilePathList(data?.productImage);
      // console.log('images',filePathList);
    }
  }, [data]);

  useEffect(() => {
    if (
      QData?.attachments !== null &&
      QData?.attachments !== "None" &&
      QData?.attachments !== "[]"
    ) {
      setFilePathListSQ(
        QData?.attachments?.length > 0 ? QData?.attachments : [],
      );
    }
  }, [QData]);

  function UpdateAttachmentList(item) {
    let filterList = filePathList.filter((itemList) => itemList.file !== item);
    console.log("llll", filterList);
    setFilePathList(filterList);
  }

  function handleImageClick(img) {
    setSelectedImage(img);
    setIsModalOpen(true);
  }

  // const deleteSupplierQuote = () =>{
  //   axiosInstance.delete(``)
  // }

  const [viewPDF, setViewPDF] = useState(null);
  const [viewSQPDF, setViewSQPDF] = useState(null);

  const ViewPDF = async () => {
    try {
      const response = await axiosInstance.get(
        `/rfq/download-pdf/${rfqViewId}`,
        {
          responseType: "blob", // Important to specify the response type as blob
        },
      );

      // Create a Blob from the response
      const pdfBlob = new Blob([response.data], { type: "application/pdf" });

      // Create a link element
      let Viewlink = window.URL.createObjectURL(pdfBlob);
      setViewPDF(Viewlink);
    } catch (error) {
      console.error("Error downloading the PDF:", error);
    }
  };

  const ViewSQPDF = async (id) => {
    try {
      const response = await axiosInstance.get(
        `supplier-quotations/download-pdf/${id}`,
        {
          responseType: "blob", // Important to specify the response type as blob
        },
      );

      // Create a Blob from the response
      const pdfBlob = new Blob([response.data], { type: "application/pdf" });

      // Create a link element
      let Viewlink = window.URL.createObjectURL(pdfBlob);
      setViewSQPDF(Viewlink);
    } catch (error) {
      console.error("Error downloading the PDF:", error);
    }
  };

  // Removed automatic PDF fetch on load - fetch only when user clicks PDF button/chip

  const [revData, setRevData] = useState([]);
  useEffect(() => {
    if (data?.supplierQuote) getRevData(data?.supplierQuote);
  }, [data?.supplierQuote]);

  function getRevData(id) {
    axiosInstance
      .get(`/supplier-quotations/products-lists/${id}`)
      .then((res) => {
        console.log("ree", res?.data?.data);
        if (res?.data?.data) setRevData(res?.data?.data);
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  const [deleteId, setDeleteId] = useState();
  const [isModalDeleteOpen, setIsModalDeleteOpen] = useState(false);
  // const { handle } = useDeleteData(getRFQById);
  // const handleDelete = async () => handle(`/supplier-quotations/` + `${deleteId}`,setIsModalDeleteOpen);
  const deleteQuote = (id) => {
    setDeleteLoading(true);
    axiosInstance
      .delete(`/supplier-quotations/${id}`)
      .then((res) => {
        if (res?.data.status === true) {
          setDeleteLoading(false);
          toast.open({
            type: "success",
            message: "Success",
            description: res.data?.msg || "Deleted Successfully.",
          });
          setIsModalDeleteOpen(false);
          getSQById();
          refetchRfq();
          setActiveButton(1);
        } else if (res.data?.status === false && res.data?.error) {
          setDeleteLoading(false);
          toast.open({
            type: "error",
            message: "Error",
            description: res.data.error || "Network error.",
          });
        } else {
          setDeleteLoading(false);
          toast.open({
            type: "warning",
            message: "Warning",
            description: res.data?.msg || "Warning.",
          });
        }
      })
      .catch((error) => {
        console.log("error", error);
        setDeleteLoading(false);
        toast.open({
          type: "error",
          message: "Error",
          description: "Network error.",
        });
      });
  };

  //   useEffect(() => {
  //     const activeButtonValue = localStorage.getItem('activeButton');

  //     if (activeButtonValue) {
  //         setActiveButton(Number(activeButtonValue));
  //     }
  // }, []);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  // // Dummy historic prices for demonstration
  // const historicPrices = data?.productList?.map(product => product.historicPrice || 100);

  const [isPopupVisible, setIsPopupVisible] = useState(false);

  const popupCalculate = () => {
    setIsPopupVisible(!isPopupVisible);
  };

  const [isModalOpenXls, setIsModalOpenXls] = useState(false);

  const handleXlsIconClick = () => {
    setIsModalOpenXls(true);
  };

  const handleCloseModal = () => {
    setIsModalOpenXls(false);
  };

  const handleConfirmDownload = async () => {
    await downloadExcelReport(rfqViewId);
    setIsModalOpenXls(false);
  };

  const downloadExcelReport = async (rfqViewId) => {
    try {
      const response = await axiosInstance.get(
        `/rfq/export-to-excel/${rfqViewId}`,
        {
          responseType: "blob",
        },
      );

      if (response.status !== 200) {
        throw new Error("Failed to download the file");
      }

      const excelBlob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(excelBlob);
      link.download = `${data?.ref}_excel_report.xlsx`;

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the Excel file:", error);
    }
  };
  console.log("revData", revData);

  return (
    <div className="w-full h-full py-2 px-2 lg:px-4">
      <style jsx>{`
        .circle-container .circle {
          position: relative;
          display: inline-block;
        }

        .circle-container .circle .circle-tooltip {
          visibility: hidden;
          width: auto;
          background-color: #fff;
          color: #555;
          text-align: center;
          border-radius: 5px;
          padding: 5px;
          position: absolute;
          z-index: 20;
          bottom: 100%; /* Position the tooltip above the circle */
          left: 50%;
          transform: translateX(-50%);
          opacity: 0;
          transition: opacity 0.3s;
          border: 1px solid #048178;
        }

        .circle-container .circle:hover .circle-tooltip {
          visibility: visible;
          opacity: 1;
        }
      `}</style>
      <div className="w-full flex flex-col md:flex-row justify-between items-stretch md:items-center gap-2 md:gap-3 mb-3">
        <div className="w-full md:w-auto flex justify-between items-center gap-2">
          <Breadcrumb
            items={[{ name: "RFQ", link: "/procurement/rfq/" }, { name: "View" }]}
          />
          <div className="flex md:hidden items-center gap-2">
            <Link
              to={"/procurement/rfq"}
              state={{
                currentPage: pageIndex,
                searchQuery: searchQuery != "" ? searchQuery : "",
              }}
            >
              <BackButton link={true} />
            </Link>
            <DownloadButton
              handleClick={
                activeButton == 2 && data?.supplierQuote != null
                  ? downloadSQPDF
                  : downloadPDF
              }
              label={
                activeButton == 2 && data?.supplierQuote != null
                  ? "Supplier Quote PDF"
                  : "RFQ PDF"
              }
            />
            {data?.supplierQuote == null ? (
              <Link
                to={`/procurement/rfq/supplier-quotes/create`}
                state={{ data: data, from: `/procurement/rfq/view/${rfqViewId}` }}
              >
                <CreateButton label="Supplier Quote" />
              </Link>
            ) : (
              <Link
                to={`/procurement/rfq/supplier-quotes/edit/${data?.supplierQuote}`}
                state={{ data: data, from: `/procurement/rfq/view/${rfqViewId}` }}
              >
                <EditButton label="Supplier Quote" height="8" />
              </Link>
            )}
            <Link
              to={`/procurement/rfq/edit/${rfqViewId}`}
              state={{ data: data, from: `/procurement/rfq/view/${rfqViewId}` }}
            >
              <EditButton label="RFQ" height="8" />
            </Link>
          </div>
        </div>

        <div className="hidden md:flex items-center gap-2">
          <Link
            to={"/procurement/rfq"}
            state={{
              currentPage: pageIndex,
              searchQuery: searchQuery != "" ? searchQuery : "",
            }}
          >
            <BackButton link={true} />
          </Link>
          <DownloadButton
            handleClick={
              activeButton == 2 && data?.supplierQuote != null
                ? downloadSQPDF
                : downloadPDF
            }
            label={
              activeButton == 2 && data?.supplierQuote != null
                ? "Supplier Quote PDF"
                : "RFQ PDF"
            }
          />
          {data?.supplierQuote == null ? (
            <Link
              to={`/procurement/rfq/supplier-quotes/create`}
              state={{ data: data, from: `/procurement/rfq/view/${rfqViewId}` }}
            >
              <CreateButton label="Supplier Quote" />
            </Link>
          ) : (
            <Link
              to={`/procurement/rfq/supplier-quotes/edit/${data?.supplierQuote}`}
              state={{ data: data, from: `/procurement/rfq/view/${rfqViewId}` }}
            >
              <EditButton label="Supplier Quote" height="8" />
            </Link>
          )}
          <Link
            to={`/procurement/rfq/edit/${rfqViewId}`}
            state={{ data: data, from: `/procurement/rfq/view/${rfqViewId}` }}
          >
            <EditButton label="RFQ" height="8" />
          </Link>
        </div>
      </div>
      <div className="w-full flex justify-start gap-3 text-xs ml-3">
        <button
          onClick={() => handleButtonClick(1)}
          className={`flex justify-start ${activeButton === 1 ? "border-b-4 border-b-baseColor-primary font-semibold" : null
            } p-1`}
        >
          RFQ View
        </button>
        {data?.supplierQuote != null && (
          <button
            onClick={() => handleButtonClick(2)}
            className={`flex justify-start gap-1 ${activeButton === 2
              ? "border-b-4 border-b-baseColor-primary font-semibold"
              : null
              }  p-1`}
          >
            <p>Quotes {QData?.isAutoGenerated && <span className="text-xs 
            px-0 py-1 rounded-full">(History)</span>}</p>
          </button>
        )}
      </div>
      {activeButton === 1 && (
        <div className="w-full mx-auto lg:h-[calc(100vh-155px)] overflow-y-auto rounded-md lg:p-2 flex flex-col lg:flex-row gap-3 text-[#111537]">
          <div className="w-full lg:w-[70%] bg-white rounded-lg drop-shadow-lg py-1 overflow-hidden flex flex-col">
            <div className="w-[98%] bg-white px-2 mx-auto border border-gray py-2 rounded-lg flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 z-10">
              <div className="grid items-center px-2">
                <div className="flex text-[14px] mb-1 text-[#111537] font-semibold w-full">
                  <p className="">{data?.ref}</p>
                </div>
                <div className="flex flex-wrap gap-x-4 gap-y-1">
                  <p className="text-xs text-[#111537]">
                    Date :{" "}
                    {data?.date ? (
                      <NuDate
                        value={data?.date}
                        format="DD-MMM-YYYY, hh:mm A"
                      />
                    ) : (
                      "N/A"
                    )}
                  </p>
                  <p className="text-xs text-[#111537]">
                    Created By:{" "}
                    {data?.preparedByName
                      ? capitalizeFirstLetter(data?.preparedByName)
                      : "None"}
                  </p>
                </div>
              </div>
              <div className="flex gap-2 justify-end  sm:self-center">
                <div className="border rounded-md border-[#579BB1] text-xs inline-flex w-auto flex-shrink-0 justify-center">
                  <p className="bg-white text-black p-1 rounded-l-md">
                    Status{" "}
                  </p>
                  <p className="bg-[#579BB1] text-white p-1 items-center rounded-r-md">
                    {data?.status || "None"}
                  </p>
                </div>
              </div>
            </div>
            <div className="w-full flex-1 overflow-y-auto p-2 lg:pb-8">
              <div className="w-full flex flex-wrap px-2 border border-gary mt-2 rounded-lg">
                <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-1 py-1">
                  <div className="w-full flex px-2 items-start">
                    <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                      YPR
                    </p>
                    <div className="w-2/3 py-2 pl-2 text-xs text-[#606279] break-words">
                      <p>: {data?.prRef}</p>
                      <p className="pl-1.5">
                        {data?.prDate ? (
                          <NuDate
                            value={data?.prDate}
                            format="DD-MMM-YYYY, hh:mm A"
                          />
                        ) : (
                          ""
                        )}
                      </p>
                    </div>
                  </div>
                  <div className="w-full flex px-2 items-center">
                    <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                      Customer Ref.
                    </p>
                    <p className="w-2/3 py-2 pl-2 text-xs text-[#606279] break-words">
                      : {data?.customerRfq || "N/A"}
                    </p>
                  </div>
                  <div className="w-full flex px-2 items-center">
                    <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                      Priority
                    </p>
                    <p className="w-2/3 py-2 pl-2 text-xs text-[#606279] break-words">
                      : {data?.priority || "N/A"}
                    </p>
                  </div>
                  <div className="w-full flex px-2 items-center">
                    <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                      RFQ Type
                    </p>
                    <p className="w-2/3 py-2 pl-2 text-xs text-[#606279] break-words">
                      : {data?.rfqType || "N/A"}
                    </p>
                  </div>
                  <div className="w-full flex px-2 items-center">
                    <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                      Deadline
                    </p>
                    <p className="w-2/3 py-2 pl-2 text-xs text-[#606279] break-words">
                      : {(data?.deadline || data?.deadLine) ? (
                        <NuDate
                          value={data?.deadline || data?.deadLine}
                          format="DD-MMM-YYYY"
                        />
                      ) : (
                        "N/A"
                      )}
                    </p>
                  </div>
                  {data?.isEmailSent === true && (
                    <div className="w-full flex px-2 items-center">
                      <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                        Email Sent Date & Time
                      </p>
                      <p className="w-2/3 py-2 pl-2 text-xs text-[#606279] break-words">
                        :{" "}
                        {data?.emailSentDateTime ? (
                          <NuDate
                            value={data?.emailSentDateTime}
                            format="DD-MMM-YYYY, hh:mm A"
                          />
                        ) : (
                          "N/A"
                        )}
                      </p>
                    </div>
                  )}

                  {data && (
                    <>
                      {data.approvedByName && (
                        <div className="w-full flex px-2 items-center">
                          <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                            Approved By
                          </p>
                          <p className="w-2/3 py-2 pl-2 text-xs text-[#606279] break-words">
                            :{" "}
                            {data.approvedByName
                              ? capitalizeFirstLetter(data.approvedByName)
                              : "N/A"}
                          </p>
                        </div>
                      )}
                      {data.reviewedByName && (
                        <div className="w-full flex px-2 items-center">
                          <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                            Reviewed By
                          </p>
                          <p className="w-2/3 py-2 pl-2 text-xs text-[#606279] break-words">
                            :{" "}
                            {data.reviewedByName
                              ? capitalizeFirstLetter(data.reviewedByName)
                              : "N/A"}
                          </p>
                        </div>
                      )}
                      {data.verifiedByName && (
                        <div className="w-full flex px-2 items-center">
                          <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                            Verified By
                          </p>
                          <p className="w-2/3 py-2 pl-2 text-xs text-[#606279] break-words">
                            :{" "}
                            {data.verifiedByName
                              ? capitalizeFirstLetter(data.verifiedByName)
                              : "N/A"}
                          </p>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
              <div className="flex flex-col sm:flex-row gap-4 mt-4">
                <div className="w-full sm:w-1/2">
                  <p className="text-xs font-medium text-[#111537] p-1">
                    Comments
                  </p>
                  <div className="border border-gary h-28 overflow-y-scroll rounded-lg items-center">
                    <p className="text-xs p-2 break-words text-[#606279]">
                      {data?.comments || "-"}
                    </p>
                  </div>
                </div>
                <div className="w-full sm:w-1/2">
                  <p className="p-1 text-xs font-medium text-[#111537]">
                    RFQ Attachments
                  </p>
                  <div className="border border-gary overflow-y-scroll h-28 rounded-lg p-2">
                    <div className="w-full flex gap-2 items-center flex-wrap">
                      {data?.attachments &&
                        filePathList.map((imgs, idx) => {
                          return <FilesView fileView={imgs} key={idx} />;
                        })}
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full bg-white border border-gary mt-4 rounded-lg mb-2 overflow-x-auto">
                <div className="w-full min-w-[500px]">
                  <div className="w-full py-2 bg-baseColor-primary flex justify-between rounded-t-lg px-2">
                    <p className="w-[8%] text-center text-white text-xs font-medium">
                      S.N.
                    </p>
                    <p className="w-[52%] text-left text-white text-xs font-medium">
                      Product
                    </p>
                    <p className="w-[15%] text-center text-white text-xs font-medium">
                      Unit
                    </p>
                    <p className="w-[25%] text-center text-white text-xs font-medium">
                      Quantity
                    </p>
                  </div>
                  {formatDisplaySno2(data?.productList || []).map((List, index) => {
                    return (
                      <div
                        key={index}
                        className="w-full py-2 flex justify-between odd:bg-white even:bg-slate-100 px-2 relative"
                        onMouseEnter={() => setHoveredIndex(index)}
                        onMouseLeave={() => setHoveredIndex(null)}
                      >
                        <p className="w-[8%] text-center text-xs font-medium text-[#111537] py-1">
                          {List?.display_sno || index + 1}
                        </p>
                        <p className="w-[52%] text-left text-xs font-medium text-[#111537] py-1 break-words">
                          {List?.product_name}
                        </p>
                        <p className="w-[15%] text-center text-xs font-medium text-[#111537] py-1">
                          {List?.product_unit}
                        </p>
                        <p className="w-[25%] text-center text-xs font-medium text-[#111537] py-1">
                          {List?.quantity}
                        </p>
                        {hoveredIndex === index &&
                          List?.price_History?.price.length > 0 ? (
                          <div className="absolute top-2 left-4 bg-white border border-gray-300 p-1 rounded shadow-md z-10">
                            <p className="text-xs text-gray-700">
                              Historical Price: {List?.price_History?.currency}{" "}
                              {List?.price_History?.price} from{" "}
                              {List?.price_History?.supplier}
                            </p>
                          </div>
                        ) : (
                          hoveredIndex === index && (
                            <div className="absolute top-2 left-4 bg-white border border-gray-300 p-1 rounded shadow-md z-10">
                              <p className="text-xs text-gray-700">
                                Historical Price - Not available
                              </p>
                            </div>
                          )
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
          <div className="w-full lg:w-[30%] bg-white rounded-lg drop-shadow-lg p-2 flex flex-col gap-3 overflow-auto">
            <div className="w-full flex flex-col gap-3">
              <div className="w-full grid border border-gary rounded-lg overflow-hidden">
                {data && (
                  <>
                    {data?.vendor && (
                      <>
                        <div className="bg-baseColor-primary text-xs p-2">
                          <p className="text-xs text-white font-medium">
                            Supplier
                          </p>
                        </div>
                        <div className="w-full flex px-2 justify-between">
                          <p className="py-3 text-xs text-[#606279] break-words">
                            {data.vendorName}
                          </p>
                        </div>
                      </>
                    )}
                    {data?.purchaser && (
                      <>
                        <div className="bg-baseColor-primary text-xs p-2">
                          <p className="text-xs text-white font-medium">
                            Local Purchaser
                          </p>
                        </div>
                        <div className="w-full flex px-2 justify-between">
                          <p className="py-3 text-xs text-[#606279] break-words">
                            {data.purchaserName}
                          </p>
                        </div>
                      </>
                    )}
                  </>
                )}
              </div>
              <div className="w-full grid border border-gary rounded-lg overflow-hidden">
                <p className="text-xs text-white bg-baseColor-primary p-2 font-medium">
                  Documents
                </p>
                <div className="w-full flex flex-wrap p-2 gap-1 max-h-32 overflow-y-auto">
                  <div
                    onClick={handlePdfIconClick}
                    className="cursor-pointer m-1 w-auto h-[25px] flex items-center justify-between rounded p-[2px] border"
                  >
                    <svg
                      width="20"
                      height="20"
                      fill="#048178"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path d="M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z" />
                    </svg>
                    <p className="w-auto text-[10px] truncate max-w-[120px]">{data?.ref}</p>
                  </div>

                  <div
                    onClick={handleXlsIconClick}
                    className="cursor-pointer m-1 w-auto h-[25px] flex items-center justify-between rounded p-[2px] border"
                  >
                    <Xlss />
                    <p className="w-auto text-[10px] truncate max-w-[140px]">
                      {data?.ref}_excel_report.xlsx
                    </p>
                  </div>
                </div>
              </div>
              <div className="w-full h-auto flex border border-gary rounded-lg">
                <CommonComments
                  visible={true}
                  title="Comments"
                  mainId={data?.prId}
                  addurl={"/pr-comments/new-comment"}
                  geturl={`/pr-comments/by-PR/${data?.prId}`}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      {activeButton === 2 && (
        <div className="w-full mx-auto lg:h-[calc(100vh-155px)] rounded-md overflow-y-auto p-2 flex flex-col gap-3 text-[#111537]">
          <div className="w-full min-h-[60%] flex flex-col lg:flex-row gap-3">
            <div className="w-full lg:w-[70%] pb-10 bg-white rounded-lg drop-shadow-lg py-1 overflow-hidden">
              <div className="w-[98%] px-2 mx-auto border border-gray py-2 rounded-lg flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 z-10">
                <div className="grid items-center px-2 w-full sm:w-[80%]">
                  <div className="flex text-[14px] mb-2 text-[#111537] font-semibold w-full">
                    <p className="">Quotes : {QData.ref}</p>
                  </div>
                  <div className="flex flex-wrap gap-x-4 gap-y-1">
                    <p className="text-xs text-[#111537]">
                      Date :{" "}
                      {QData?.createdAt ? (
                        <NuDate
                          value={QData?.createdAt}
                          format="DD-MMM-YYYY, hh:mm A"
                        />
                      ) : (
                        "N/A"
                      )}
                    </p>
                    <p className="text-xs text-[#111537]">
                      Created By:{" "}
                      {QData.preparedByName
                        ? capitalizeFirstLetter(data.preparedByName)
                        : "None"}
                    </p>
                  </div>
                </div>

                <div className="flex flex-row sm:flex-col items-center sm:items-end justify-between sm:justify-center gap-2 w-full sm:w-auto">
                  <div className="pb-1 flex justify-end">
                    <div
                      className="cursor-pointer"
                      onClick={() => {
                        setDeleteId(data?.supplierQuote);
                        setIsModalDeleteOpen(true);
                      }}
                    >
                      <DeleteIcon />
                    </div>
                  </div>

                  <div className="flex justify-end">
                    <div className="border rounded-md border-[#579BB1] text-xs inline-flex w-auto justify-end">
                      <p className="bg-white text-black p-1 rounded-l-md">
                        Status{" "}
                      </p>
                      <p className="bg-[#579BB1] text-white p-1 items-center rounded-r-md">
                        {QData.status || "None"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="h-full overflow-y-auto p-2 pb-8">
                <div className="w-full flex flex-wrap px-2 border border-gary rounded-lg">
                  <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-1 py-1">
                    <div className="w-full flex px-1 sm:px-2 items-start sm:items-center">
                      <p className="w-5/12 sm:w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                        Quotation Validity
                      </p>
                      <p className="w-7/12 sm:w-2/3 py-2 pl-2 text-xs font-medium text-[#606279] break-words">
                        : {QData.validity || "N/A"}
                      </p>
                    </div>

                    <div className="w-full flex px-1 sm:px-2 items-start sm:items-center">
                      <p className="w-5/12 sm:w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                        Delivery Terms
                      </p>
                      <p className="w-7/12 sm:w-2/3 py-2 pl-2 text-xs font-medium text-[#606279] break-words">
                        : {QData.deliverTerms || "N/A"}
                      </p>
                    </div>

                    <div className="w-full flex px-1 sm:px-2 items-start sm:items-center">
                      <p className="w-5/12 sm:w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                        Payment Terms
                      </p>
                      <p className="w-7/12 sm:w-2/3 py-2 pl-2 text-xs font-medium text-[#606279] break-words">
                        : {QData.paymentTerms || "N/A"}
                      </p>
                    </div>
                    <div className="w-full flex px-1 sm:px-2 items-start sm:items-center">
                      <p className="w-5/12 sm:w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                        Payment Method
                      </p>
                      <p className="w-7/12 sm:w-2/3 py-2 pl-2 text-xs font-medium text-[#606279] break-words">
                        : {QData.paymentMethod || "N/A"}
                      </p>
                    </div>
                    {QData.vendorCurrency && (
                      <div className="w-full flex px-1 sm:px-2 items-start sm:items-center">
                        <p className="w-5/12 sm:w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                          Currency
                        </p>
                        <p className="w-7/12 sm:w-2/3 py-2 pl-2 text-xs font-medium text-[#606279] break-words">
                          : {QData.vendorCurrency}
                        </p>
                      </div>
                    )}
                    <div className="w-full flex px-1 sm:px-2 items-start sm:items-center">
                      <p className="w-5/12 sm:w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                        Exchange Rate
                      </p>
                      <p className="w-7/12 sm:w-2/3 py-2 pl-2 text-xs font-medium text-[#606279] break-words">
                        : {QData.exchangeRate || "N/A"}
                      </p>
                    </div>
                    {QData && (
                      <>
                        {QData.reviewedByName && (
                          <div className="w-full flex px-1 sm:px-2 items-start sm:items-center">
                            <p className="w-5/12 sm:w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                              Reviewed By
                            </p>
                            <p className="w-7/12 sm:w-2/3 py-2 pl-2 text-xs font-medium text-[#606279] break-words">
                              :{" "}
                              {data.reviewedByName
                                ? capitalizeFirstLetter(QData.reviewedByName)
                                : "N/A"}
                            </p>
                          </div>
                        )}
                        {QData.approvedByName && (
                          <div className="w-full flex px-1 sm:px-2 items-start sm:items-center">
                            <p className="w-5/12 sm:w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                              Approved By
                            </p>
                            <p className="w-7/12 sm:w-2/3 py-2 pl-2 text-xs font-medium text-[#606279] break-words">
                              :{" "}
                              {data.approvedByName
                                ? capitalizeFirstLetter(QData.approvedByName)
                                : "N/A"}
                            </p>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
                <div className="flex flex-col sm:flex-row gap-4 mt-1 pb-2">
                  <div className="w-full sm:w-1/2">
                    <p className=" pl-1 text-xs font-medium text-[#111537] p-1">
                      Special Notes from Supplier
                    </p>
                    <div className="  border border-gary  h-28 overflow-y-scroll rounded-lg items-center">
                      <p className=" text-xs p-2 text-wrap text-[#606279]">
                        {QData.specialNotes || "-"}
                      </p>
                    </div>
                  </div>
                  <div className="w-full sm:w-1/2">
                    <p className=" p-1 text-xs font-medium text-[#111537]">
                      Supplier Quote Attachments
                    </p>
                    <div className=" border border-gary  overflow-y-scroll h-28 rounded-lg p-2">
                      <div className="w-full flex gap-2 items-center flex-wrap mt-1 ">
                        {QData?.attachments &&
                          filePathListSQ.map((imgs, idx) => {
                            console.log("img", imgs);
                            return <FilesView fileView={imgs} key={idx} />;
                          })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full lg:w-[30%] bg-white rounded-lg drop-shadow-lg p-2">
              <div className=" overflow-y-scroll p-2 h-full ">
                <div className="w-full grid  border border-gary    rounded-lg">
                  {/* <p className="text-xs text-[#111537] font-medium"></p> */}
                  <div className="bg-baseColor-primary   p-2 rounded-t-lg">
                    <p className="text-xs text-white font-medium">
                      Quote Detail
                    </p>
                  </div>
                  <div className=" w-full px-2">
                    <table className=" w-full border-collapse text-left">
                      <TempTrCom
                        label="YPR"
                        value={QData?.prRef || ""}
                        subValue={
                          QData?.prDate ? (
                            <NuDate
                              value={QData?.prDate}
                              format="DD-MMM-YYYY, hh:mm A"
                            />
                          ) : (
                            ""
                          )
                        }
                      />
                      {QData?.purchaserName && (
                        <TempTrCom
                          label="Purchaser"
                          value={QData.purchaserName || ""}
                        />
                      )}

                      <TempTrCom
                        label="Supplier"
                        value={QData.vendorName || "-"}
                      />
                      <TempTrCom
                        label=" RFQ Ref."
                        value={QData.rfqRef || "-"}
                      />
                    </table>
                  </div>
                </div>
                <div className="w-full grid  border border-gary mt-4 rounded-lg ">
                  <p className="text-xs text-white font-medium bg-baseColor-primary   p-2 rounded-t-lg">
                    Documents{" "}
                  </p>
                  <div className="flex gap-2 flex-wrap overflow-y-scroll h-16">
                    <div
                      onClick={handlePdfIconClickSQ}
                      className="cursor-pointer m-1 w-auto  h-[25px] flex items-center    rounded p-[2px] border "
                    >
                      <svg
                        width="20"
                        height="20"
                        fill="#048178"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                      >
                        <path d="M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z" />
                      </svg>
                      <p className="w-auto text-[10px]">{QData?.ref}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className=" w-full lg:h-[calc(100vh-190px)]  rounded-md bg-white">
            {/* <Tabs>
              {revData &&
                revData.map((item, index) => (
                  <Tab
                    component={
                      <> */}
            <div
              className={`w-full max-w-full max-h-[calc(100vh-190px)] overflow-y-auto overflow-x-auto relative border border-slate-200/80 rounded-lg`}
            >
              <table className="table-auto relative  border-collapse bg-white mt-2 z-0">
                <thead className="bg-baseColor-primary sticky top-0 text-white text-xs 2xl:text-sm z-[9] ">
                  <tr>
                    <th className=" lg:sticky  left-0 bg-baseColor-primary z-[3]  h-10    ">
                      <div className=" flex  w-full  items-center">
                        <div className=" w-[80px]   flex justify-center items-center text-center ">
                          S.N.
                        </div>
                        <div className=" w-[450px]  flex  pl-2 text-left ">
                          Product
                        </div>
                      </div>
                    </th>
                    <th className="  ">
                      <div className=" flex  w-full  items-center">
                        <div className=" w-[130px]   flex justify-center items-center text-center ">
                          Unit
                        </div>
                        <div className=" w-[130px]  flex justify-center items-center text-center ">
                          Quantity
                        </div>
                        <div className=" w-[130px]  flex justify-center items-center text-center ">
                          Lead Time
                        </div>
                        <div className=" w-[160px]  flex justify-center items-center text-center ">
                          Unit Price
                        </div>
                        <div className=" w-[160px]  flex justify-center items-center text-center ">
                          Conv. Price
                        </div>
                        <div className=" w-[130px]  flex justify-center items-center text-center ">
                          Weight
                        </div>
                        <div className=" w-[140px]  flex justify-center items-center text-center ">
                          Amount
                        </div>
                        <div className=" w-[140px]  flex justify-center items-center text-center ">
                          Freight Charge
                        </div>
                        <div className=" w-[160px]  flex justify-center items-center text-center ">
                          Total with Freight
                        </div>
                        <div className=" w-[180px]  flex justify-center items-center text-center ">
                          Duty
                        </div>
                        <div className=" w-[180px]  flex justify-center items-center text-center ">
                          Local Charge
                        </div>
                        <div className=" w-[150px]  flex justify-center items-center text-center ">
                          Final Unit Price
                        </div>
                        <div className=" w-[150px]  flex justify-center items-center text-center ">
                          Total
                        </div>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody className="z-[0]">
                  {revData[0]?.revProduct &&
                    formatDisplaySno2(revData[0]?.revProduct || []).map((List, index) => {
                      const qty = Math.max(0, Number(List?.quantity) || 0);
                      const price = Number(List?.price) || 0;
                      const convPrice = Number(List?.convPrice) || 0;
                      const weight = Number(List?.weight) || 0;
                      const amount = List?.amount !== undefined && List?.amount !== null ? Number(List.amount) : parseFloat((convPrice * qty).toFixed(2));
                      const freight = Number(List?.freightCharge !== undefined && List?.freightCharge !== null ? List.freightCharge : (List?.freight !== undefined && List?.freight !== null ? List.freight : (List?.trans || 0)));
                      const totalWithFreight = List?.totalWithFreight !== undefined && List?.totalWithFreight !== null ? Number(List.totalWithFreight) : parseFloat((amount + freight).toFixed(2));

                      const dutyType = List?.dutyType || "percent";
                      const dutyVal = Number(List?.duty !== undefined && List?.duty !== null ? List.duty : (List?.dutyValue !== undefined && List?.dutyValue !== null ? List.dutyValue : (List?.dutty || 0)));
                      const dutyAmount = dutyType === "percent" ? (totalWithFreight * dutyVal) / 100 : dutyVal;

                      const localChargeType = List?.localChargeType || "cost";
                      const localChargeVal = Number(List?.localCharge !== undefined && List?.localCharge !== null ? List.localCharge : (List?.localChargeValue !== undefined && List?.localChargeValue !== null ? List.localChargeValue : 0));
                      const localChargeAmount = localChargeType === "percent" ? (totalWithFreight * localChargeVal) / 100 : localChargeVal;

                      const rowTotal = List?.total !== undefined && List?.total !== null ? Number(List.total) : parseFloat((totalWithFreight + dutyAmount + localChargeAmount).toFixed(2));
                      const finalUnitPrice = List?.finalUnitPrice !== undefined && List?.finalUnitPrice !== null ? Number(List.finalUnitPrice) : (qty > 0 ? parseFloat((rowTotal / qty).toFixed(2)) : 0);

                      return (
                        <tr
                          key={index}
                          className="  text-xs 2xl:text-sm border-collapse border border-slate-300"
                        >
                          <td
                            className={` text-center lg:sticky left-0  z-[1] bg-white max-h-[6.5rem]`}
                          >
                            <div className=" flex  items-center min-h-[5rem] max-h-[6.5rem] relative group">
                              <div className=" w-[80px] text-center min-h-[5rem] max-h-[6.5rem] border-r border-[#acaaaa] flex justify-center items-center">
                                {List?.display_sno}
                              </div>
                              <div className=" w-[450px] flex flex-col justify-center  text-left line-clamp-2 min-h-[5rem] max-h-[6.5rem] border-r border-[#acaaaa]  px-2 items-center pt-0.5">
                                <div className=" w-full max-h-[74px]">
                                  <p className=" w-[98%] line-clamp-6  text-left  text-xs font-medium text-[#111537] ">
                                    {List?.product_name || " "}
                                  </p>
                                </div>
                                {List?.isAlternate === true && (
                                  <div className=" w-full max-h-[15px]">
                                    <p className="text-[10px] text-slate-400">
                                      (Alternate)
                                    </p>
                                  </div>
                                )}
                                {List?.notes && (
                                  <>
                                    <div className=" w-full max-h-[15px]">
                                      <p className="text-left text-gray-500 text-[11px] font-thin truncate">
                                        Notes: {List?.notes}
                                      </p>
                                    </div>

                                    <div
                                      className={`absolute hidden group-hover:block bg-gray-200 text-black text-[12px] max-h-[150px] ${List?.notes.length > 150
                                        ? "w-[450px] left-[20px]"
                                        : "max-w-[300px] left-[60px]"
                                        }  font-light rounded-md px-1 py-1 shadow-lg bottom-0  z-[999]`}
                                    >
                                      <p>{List?.notes}</p>
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          </td>
                          <td className="bg-white min-h-[5rem] max-h-[6.5rem] ">
                            <div className=" w-full min-h-[5rem] max-h-[6.5rem] flex items-center border-collapse">
                              <div
                                className={`min-h-[5rem] max-h-[6.5rem] text-center text-xs font-medium text-[#111537]  w-[130px] px-2 flex justify-center items-center`}
                              >
                                {List?.product_unit || "-"}
                              </div>
                              <div
                                className={`min-h-[5rem] max-h-[6.5rem] text-center text-xs font-medium text-[#111537]  w-[130px] px-2 border-x border-slate-300 flex justify-center items-center`}
                              >
                                {List?.quantity || "-"}
                              </div>
                              <div
                                className={`min-h-[5rem] max-h-[6.5rem] text-center text-xs font-medium text-[#111537]  w-[130px] px-2 border-x border-slate-300 flex justify-center items-center`}
                              >
                                {List?.leadTime || "-"}
                              </div>
                              <div
                                className={`min-h-[5rem] max-h-[6.5rem]  text-center text-xs font-medium text-[#111537]  w-[160px] px-2 border-x border-slate-300 flex justify-center items-center`}
                              >
                                {price.toLocaleString(
                                  undefined,
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  },
                                )}
                              </div>
                              <div
                                className={`min-h-[5rem] max-h-[6.5rem]  text-center text-xs font-medium text-[#111537]  w-[160px] px-2 border-x border-slate-300 flex justify-center items-center`}
                              >
                                {convPrice.toLocaleString(
                                  undefined,
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  },
                                )}
                              </div>
                              <div
                                className={`min-h-[5rem] max-h-[6.5rem]  text-center text-xs font-medium text-[#111537]  w-[130px] px-2 border-x border-slate-300 flex justify-center items-center`}
                              >
                                {List?.weight !== undefined && List?.weight !== null && List?.weight !== ""
                                  ? `${weight.toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })} ${List?.weightUnit || List?.weight_unit || "kg"}`
                                  : "-"}
                              </div>
                              <div
                                className={`min-h-[5rem] max-h-[6.5rem]  text-center text-xs font-medium text-[#111537]  w-[140px] px-2 border-x border-slate-300 flex justify-center items-center`}
                              >
                                {amount.toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </div>
                              <div
                                className={`min-h-[5rem] max-h-[6.5rem]  text-center text-xs font-medium text-[#111537]  w-[140px] px-2 border-x border-slate-300 flex justify-center items-center`}
                              >
                                {freight.toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </div>
                              <div
                                className={`min-h-[5rem] max-h-[6.5rem]  text-center text-xs font-medium text-[#111537]  w-[160px] px-2 border-x border-slate-300 flex justify-center items-center`}
                              >
                                {totalWithFreight.toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </div>
                              <div
                                className={`min-h-[5rem] max-h-[6.5rem]  text-center text-xs font-medium text-[#111537]  w-[180px] px-2 border-x border-slate-300 flex flex-col justify-center items-center`}
                              >
                                {dutyType === "cost" ? (
                                  <>
                                    <div>
                                      {dutyVal.toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })}
                                    </div>
                                    <p className="text-[9px] text-gray-500">
                                      ({totalWithFreight > 0 ? ((dutyAmount / totalWithFreight) * 100).toFixed(1) : "0.0"}%)
                                    </p>
                                  </>
                                ) : (
                                  <>
                                    <div>{dutyVal}%</div>
                                    <p className="text-[9px] text-gray-500">
                                      Amt:{" "}
                                      <span className="text-red-900 font-medium">
                                        {dutyAmount.toLocaleString(undefined, {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })}
                                      </span>
                                    </p>
                                  </>
                                )}
                              </div>
                              <div
                                className={`min-h-[5rem] max-h-[6.5rem]  text-center text-xs font-medium text-[#111537]  w-[180px] px-2 border-x border-slate-300 flex flex-col justify-center items-center`}
                              >
                                {localChargeType === "percent" ? (
                                  <>
                                    <div>{localChargeVal}%</div>
                                    <p className="text-[9px] text-gray-500">
                                      Amt:{" "}
                                      <span className="text-red-900 font-medium">
                                        {localChargeAmount.toLocaleString(undefined, {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })}
                                      </span>
                                    </p>
                                  </>
                                ) : (
                                  <>
                                    <div>
                                      {localChargeVal.toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })}
                                    </div>
                                    <p className="text-[9px] text-gray-500">
                                      ({totalWithFreight > 0 ? ((localChargeAmount / totalWithFreight) * 100).toFixed(1) : "0.0"}%)
                                    </p>
                                  </>
                                )}
                              </div>
                              <div
                                className={`min-h-[5rem] max-h-[6.5rem]  text-center text-xs font-medium text-[#111537]  w-[150px] px-2 border-x border-slate-300 flex justify-center items-center`}
                              >
                                {finalUnitPrice.toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </div>
                              <div
                                className={`min-h-[5rem] max-h-[6.5rem]  text-center text-xs font-semibold text-[#111537]  w-[150px] px-2 border-x border-slate-300 flex justify-center items-center`}
                              >
                                {rowTotal.toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </div>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  <tr>
                    <td
                      className={` text-center sticky left-0  z-[1] bg-white max-h-[6.5rem]`}
                    >
                      <div className="flex items-center">
                        <div className="flex justify-center items-center text-center w-[80px]  "></div>
                        <div className="flex justify-center items-center text-center w-[450px] "></div>
                      </div>
                    </td>
                    <td>
                      <div className="flex  w-full  items-center">
                        <div className="flex  justify-center items-center text-center w-[130px]"></div>
                        <div className="flex  justify-center items-center text-center w-[130px]"></div>
                        <div className="flex  justify-center items-center text-center w-[130px]"></div>
                        <div className="flex  justify-center items-center text-center w-[160px]"></div>
                        <div className="flex  justify-center items-center text-center w-[160px] "></div>
                        <div className="flex  justify-center items-center text-center w-[130px] "></div>
                        <div className="flex  justify-center items-center text-center w-[140px]"></div>
                        <div className="flex  justify-center items-center text-center w-[140px]"></div>
                        <div className="flex  justify-center items-center text-center w-[160px]"></div>
                        <div className="flex  justify-center items-center text-center w-[180px]"></div>
                        <div className="flex  justify-center items-center text-center w-[180px]"></div>
                        <div className="flex  justify-center items-center text-center w-[150px]"></div>
                        <div className="flex flex-col justify-center items-center text-center w-[150px] py-2">
                          <p className="text-xs font-medium text-[#111537]">
                            Total Price
                          </p>
                          <p className="text-xs font-bold text-[#048178]">
                            : <NuAmount value={QData?.totalPrice || 0} />
                          </p>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* </>
                    }
                    active={index == 0}
                    key={index}
                  >
                    {item?.revName}
                  </Tab>
                ))}
            </Tabs> */}
          </div>
        </div>
      )}
      {showPdfComponent && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in relative w-[99%] h-[99%] bg-white py-2 px-4 rounded-md shadow-lg overflow-y-scroll flex flex-col">
            <button
              className="absolute top-2 right-2 text-white bg-red-600 rounded p-1 z-10"
              onClick={() => setShowPdfComponent(false)}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
            {pdfLoading ? (
              <div className="w-full h-full flex flex-col items-center justify-center gap-3">
                <div className="w-8 h-8 border-4 border-emerald-600 border-t-transparent rounded-full animate-spin"></div>
                <p className="text-gray-600 font-medium text-sm">Loading PDF preview...</p>
              </div>
            ) : (
              <PDFViewer pdfFile={viewPDF} />
            )}
          </div>
        </div>
      )}
      {showPdfComponentSQ && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in relative w-[99%] h-[99%] bg-white py-2 px-4 rounded-md shadow-lg overflow-y-scroll flex flex-col">
            <button
              className="absolute top-2 right-2 text-white bg-red-600 rounded p-1 z-10"
              onClick={() => setShowPdfComponentSQ(false)}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
            {pdfLoadingSQ ? (
              <div className="w-full h-full flex flex-col items-center justify-center gap-3">
                <div className="w-8 h-8 border-4 border-emerald-600 border-t-transparent rounded-full animate-spin"></div>
                <p className="text-gray-600 font-medium text-sm">Loading Quotes PDF preview...</p>
              </div>
            ) : (
              <PDFViewer pdfFile={viewSQPDF} />
            )}
          </div>
        </div>
      )}

      <Modal show={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <img src={selectedImage?.file} alt={selectedImage?.file} />
      </Modal>
      <ModalContainer
        visiable={isModalDeleteOpen}
        title="Warning"
        content={`Are you sure, ${QData.ref} will removed from Quotes!`}
        handleClick={() => deleteQuote(deleteId)}
        closeModal={() => setIsModalDeleteOpen(false)}
        isLoading={deleteLoading}
      />

      {isPopupVisible && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in w-[35%] max-h-[70vh] bg-white py-6 px-4 rounded-md shadow-lg overflow-y-scroll relative">
            <div
              className="absolute top-2 right-2 w-6 h-6 rounded-md bg-red-500 hover:bg-red-700 cursor-pointer flex justify-center items-center"
              onClick={popupCalculate}
            >
              <p className="text-white text-xs text-center">X</p>
            </div>

            <h2 className="text-lg font-medium text-[14px]">Duty</h2>
            <div className="w-full flex px-2 pt-4">
              <p className="w-1/3 py-2 text-sm font-medium text-[#111537]">
                Landing Cost
              </p>
              <p className="w-[65%] py-2 text-sm font-medium text-[#606279]">
                :{" "}
                {QData?.lCost?.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </p>
            </div>
            <div className="w-full flex px-2">
              <p className="w-1/3 py-2 text-sm font-medium text-[#111537]">
                Others
              </p>
              <p className="w-[65%] py-2 text-sm font-medium text-[#606279]">
                :{" "}
                {QData?.others?.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </p>
            </div>
            <div className="w-full flex px-2">
              <p className="w-1/3 py-2 text-sm font-medium text-[#111537]">
                Total
              </p>
              <p className="w-[65%] py-2 text-sm font-medium text-[#606279]">
                :{" "}
                {QData?.boxTotal?.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </p>
            </div>
          </div>
        </div>
      )}

      {isModalOpenXls && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in w-[40%] max-h-[70vh] bg-white py-6 px-4 rounded-md shadow-lg overflow-y-scroll relative">
            <h2 className="font-semibold px-4 text-[15px]">
              Do you want to download
            </h2>
            <h2 className="font-normal text-gray-500 text-[14px] p-4">
              Are you sure you want to download {data?.ref}_excel_report.xlsx?
            </h2>

            <div className="flex gap-4 justify-center items-center text-center">
              <button
                onClick={handleCloseModal}
                className="px-5 py-[9px] cursor-pointer text-xs 2xl:text-sm bg-[#E6F2F2]  hover:bg-gray-300
                rounded-md flex items-center mr-2 text-textColor-main"
              >
                No
              </button>
              <button
                onClick={handleConfirmDownload}
                className="bg-[#048178] px-4 py-[9px] cursor-pointer outline-none border-none text-white rounded-md text-xs 2xl:text-sm flex items-center"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ViewRFQ;

function TempTrCom({ label = "", value = "", subValue = "" }) {
  return (
    <tr className="w-full">
      <td className="w-[70px]">
        <p className="py-2 text-xs font-medium text-[#111537]">{label}</p>
      </td>
      <td className="w-[10px]">:</td>
      <td className="flex-1 py-2">
        <p className=" text-xs text-[#606279] truncate text-wrap">{value}</p>
        {subValue && (
          <p className="text-xs text-[#606279] truncate text-wrap">
            {subValue}
          </p>
        )}
      </td>
    </tr>
  );
}
